import { render, staticRenderFns } from "./ActivateMember.vue?vue&type=template&id=3a0c38d4&scoped=true"
import script from "./ActivateMember.vue?vue&type=script&lang=js"
export * from "./ActivateMember.vue?vue&type=script&lang=js"
import style0 from "./ActivateMember.vue?vue&type=style&index=0&id=3a0c38d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c38d4",
  null
  
)

export default component.exports